module.exports = __webpack_public_path__ + "static/media/mail.5f611998.svg";